var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showSpinner),expression:"showSpinner"}],staticClass:"hpSpinner",on:{"click":function($event){$event.stopPropagation();}}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('img',{staticClass:"rotation",attrs:{"src":require("../assets/images/spinner/loading.png")}})])
}]

export { render, staticRenderFns }